import { AuthContext } from 'App'
import WrapperUnauthAction from 'Components/WrapperUnauthAction'
import { TextInputField } from 'NewVersion/components/UI/Forms/TextInputField'
import React, { useEffect, useState } from 'react'
import { getEmailFromToken } from 'utils/utils'

import { LoadingComponent } from 'Components/HelperComponents'
import LoginHeroImage from 'NewVersion/components/LoginHeroImage'
import Button from 'NewVersion/components/UI/Buttons/Button'
import { fetchGuillotina } from 'NewVersion/services/guillotina'
import { useEdition } from 'hooks/useEdition'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useSearchParams } from 'react-router-dom'
import 'NewVersion/styles/Login.scss'

function NewPasswordPage() {
  const [searchParams] = useSearchParams()
  const { t } = useTranslation()
  const [password, passwordChange] = useState('')
  const [password2, password2Change] = useState('')
  const [pwdError, setError] = useState({
    haveError: false,
    message: '',
  })
  const [isLoading, setLoader] = useState(false)
  const navigate = useNavigate()
  const { setLastEdition } = useEdition()

  useEffect(() => {
    let token = ''
    if (searchParams && searchParams.get('token')) {
      token = searchParams.get('token')
    }
    if (!token) {
      navigate('/')
    }
  }, [searchParams])

  const { dispatch } = React.useContext(AuthContext)
  const validateForm = (e) => {
    return false
  }

  const onNewPassword = async (event) => {
    event.preventDefault()
    setError({ haveError: false, message: '' })
    if (password !== password2) {
      setError({
        haveError: true,
        message: t('passwords_match'),
      })
      return false
    } else {
      setError({
        haveError: false,
        message: false,
      })
    }

    setLoader(true)
    await fetchGuillotina({
      path: `@validate/${searchParams.get('token')}`,
      method: 'POST',
      checkError: true,
      unAuth: true,
      data: { password: password },
    })
      .then(function (response) {
        if (!response.token) {
          navigate('/')
        }
        localStorage.setItem('token', response.token)
        localStorage.setItem('isAuthenticated', true)
        passwordChange('')
        const token_val = response.token
        const obj_pay = {
          user: getEmailFromToken(token_val),
          token: token_val,
        }
        dispatch({
          type: 'LOGIN',
          payload: obj_pay,
        })

        setLastEdition()
        setLoader(false)

        if (localStorage.reRoute !== 'login') {
          const rout = localStorage.reRoute
          localStorage.removeItem('reRoute')
          navigate(rout)
        } else {
          navigate('/')
        }
      })
      .catch(function () {
        setError({
          haveError: true,
          message: t('register_error'),
        })
        setLoader(false)
        passwordChange('')
        password2Change('')
      })
  }

  return (
    <WrapperUnauthAction>
      <section className="login">
        <div className="input-container">
          <h2 className="input-title">{t('Benvinguda')}</h2>
          <form className="inputs" onSubmit={onNewPassword} data-test="resetPasswTest">
            <TextInputField
              type="password"
              name="password"
              label={t('password')}
              onChange={({ target }) => passwordChange(target.value)}
              dataTest="inpuPasswordTest"
              value={password}
              aria-label="Password"
            />
            <TextInputField
              type="password"
              label={t('password_repeat')}
              name="passwordRepeat"
              onChange={({ target }) => password2Change(target.value)}
              dataTest="inpuPasswordRepeatTest"
              value={password2}
              aria-label={t('password_repeat')}
              error={pwdError.haveError}
              helperText={pwdError.haveError ? pwdError.message : ''}
            />
            {pwdError.haveError && <p className="error">{pwdError.message}</p>}
            {!isLoading ? (
              <Button
                disabled={validateForm()}
                color="primary"
                type="submit"
                aria-label="Login button"
              >
                {t('new_password')}
              </Button>
            ) : (
              <div style={{ height: '56px' }}>
                <LoadingComponent noClass={true} />
              </div>
            )}
          </form>
        </div>
        <LoginHeroImage />
      </section>
    </WrapperUnauthAction>
  )
}

export default NewPasswordPage
